export default {
  AssetCode: "Mã tài sản",
  AssetList: {
    AssetName: "Tài sản",
  },
  Error: "Lỗi không lấy được layout mặc định",
};
